interface BaseNotificationBadgeProps {
  hasNotification: boolean;
  className?: string;
}

const BaseNotificationBadge = ({
  hasNotification,
  className = '',
}: BaseNotificationBadgeProps) => {
  if (!hasNotification) return null;

  return (
    <span
      className={`absolute -top-1 -right-1 w-2 h-2 bg-critical-500 rounded-full border border-white ${className}`}
    />
  );
};

export default BaseNotificationBadge;
